import React, { lazy } from 'react';

import {
  AppstoreAddOutlined,
  AppstoreOutlined,
  BarsOutlined,
  ClusterOutlined,
  DollarOutlined,
  EyeInvisibleOutlined,
  ForkOutlined,
  GoldenFilled,
  HistoryOutlined,
  HomeFilled,
  HomeOutlined,
  LayoutOutlined,
  LinkOutlined,
  MoneyCollectOutlined,
  NotificationOutlined,
  PercentageOutlined,
  PicCenterOutlined,
  ShoppingCartOutlined,
  SketchOutlined,
  SmileOutlined,
  TeamOutlined,
  UserOutlined,
  LineChartOutlined,
  MessageFilled,
  WalletOutlined,
  DollarCircleOutlined,
  RocketOutlined,
  PoundOutlined,
  ToTopOutlined,
  BookOutlined,
  VerticalAlignMiddleOutlined,
  DotChartOutlined,
  RedEnvelopeOutlined,
  PlusCircleOutlined,
  DisconnectOutlined,
  CarOutlined,
  LayoutFilled,
  RollbackOutlined,
} from '@ant-design/icons';

const options = [
  {
    key: Math.random(),
    path: '/',
    component: lazy(() => import('../orders')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'orders',
    permissionKey: '/'
  },
  {
    key: Math.random(),
    path: '/couriers',
    component: lazy(() => import('../couriers')),
    exact: true,
    icon: <CarOutlined />,
    name: 'couriers',
    // Gated on the orders permission so anyone who assigns couriers can manage
    // the fleet. Switch to a dedicated '/couriers' permission once it is added
    // to the backend permissions list.
    permissionKey: '/'
  },
  {
    key: Math.random(),
    path: '/returnFulfillment',
    component: lazy(() => import('../returnFulfillment')),
    exact: true,
    icon: <RollbackOutlined />,
    name: 'return_fulfillment',
    permissionKey: '/returnFulfillment'
  },
  {
    key: Math.random(),
    path: '/purchaseOrder',
    component: lazy(() => import('../purchaseOrder')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'purchase_orders',
    permissionKey: '/purchaseOrders'
  },
  {
    key: Math.random(),
    path: '/location',
    component: lazy(() => import('../location')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'location',
    permissionKey: '/location'
  },
  {
    key: Math.random(),
    path: '/sublocation',
    component: lazy(() => import('../sublocation')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'sublocation',
    permissionKey: '/sublocation'
  },
  {
    key: Math.random(),
    path: '/storageUnit',
    component: lazy(() => import('../storageUnit')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'storageUnit',
    permissionKey: '/storageUnit'
  },
  {
    key: Math.random(),
    path: '/inventory',
    component: lazy(() => import('../inventory')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'inventory',
    permissionKey: '/inventory'
  },
  {
    key: Math.random(),
    path: '/stockTake',
    component: lazy(() => import('../stockTake')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'stock_take',
    permissionKey: '/stockTake'
  },

  {
    key: Math.random(),
    path: '/stockTake/count/:stockTakeId',
    component: lazy(() => import('../stockTake/StockTakeCount/index')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'stock_take_count',
    hidden: true,
    permissionKey: '/stockTake'
  },

  {
    key: Math.random(),
    path: '/groceryBulkEntryConstants',
    component: lazy(() => import('../groceryBulkEntryConstants')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'grocery_bulk_entry_constants',
    permissionKey: '/groceryBulkEntryConstants'
  },
  {
    key: Math.random(),
    path: '/groceryBulkEntry',
    component: lazy(() => import('../groceryBulkEntry')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'grocery_bulk_entry',
    permissionKey: '/groceryBulkEntry'
  },
  {
    key: Math.random(),
    path: '/groceryBulkEntry/count/:groceryBulkEntryId',
    component: lazy(() => import('../groceryBulkEntry/groceryBulkEntryCount')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'grocery_bulk_entry_count',
    hidden: true,
    permissionKey: '/groceryBulkEntryCount'
  },
  {
    key: Math.random(),
    path: '/transfer',
    component: lazy(() => import('../transfer')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'transfer',
    permissionKey: '/transfer'
  },
  {
    key: Math.random(),
    path: '/purchaseRequest',
    component: lazy(() => import('../purchaseRequests')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'purchase_request',
    permissionKey: '/purchaseRequest'
  },
  {
    key: Math.random(),
    path: '/quotation',
    component: lazy(() => import('../quotation')),
    exact: true,
    icon: <ClusterOutlined />,
    name: 'quotation',
    permissionKey: '/quotation'
  },
  {
    key: Math.random(),
    path: '/categories',
    component: lazy(() => import('../categories')),
    exact: true,
    icon: <BarsOutlined />,
    name: 'categories',
    permissionKey: '/categories'
  },
  {
    key: Math.random(),
    path: '/products',
    component: lazy(() => import('../products')),
    exact: true,
    icon: <GoldenFilled />,
    name: 'products',
    permissionKey: '/products'
  },
  {
    key: Math.random(),
    path: '/brands',
    component: lazy(() => import('../brands')),
    exact: true,
    icon: <SketchOutlined />,
    name: 'brands',
    permissionKey: '/brands'
  },
  {
    key: Math.random(),
    path: '/b2b_b2c_linking',
    component: lazy(() => import('../b2b-b2c')),
    exact: true,
    icon: <MoneyCollectOutlined />,
    name: 'B2B B2C Linking',
    permissionKey: '/b2b_b2c_linking'
  },
  {
    key: Math.random(),
    path: '/clients',
    component: lazy(() => import('../clients')),
    exact: true,
    icon: <TeamOutlined />,
    name: 'clients',
    permissionKey: '/clients'
  },
  {
    key: Math.random(),
    path: '/logger',
    component: lazy(() => import('../logger')),
    exact: true,
    icon: <HistoryOutlined />,
    name: 'logger',
    permissionKey: '/logger'
  },
  {
    key: Math.random(),
    path: '/usersAccounts',
    component: lazy(() => import('../usersAccounts')),
    exact: true,
    icon: <UserOutlined />,
    name: 'users_account',
    permissionKey: '/usersAccounts'
  },
  {
    key: Math.random(),
    path: '/banners',
    component: lazy(() => import('../banners')),
    exact: true,
    icon: <PicCenterOutlined />,
    name: 'banners',
    permissionKey: '/banners'
  },
  {
    key: Math.random(),
    path: '/notification',
    component: lazy(() => import('../notification')),
    exact: true,
    icon: <NotificationOutlined />,
    name: 'notifications',
    permissionKey: '/notifications'
  },
  {
    key: Math.random(),
    path: '/customers',
    component: lazy(() => import('../customers')),
    exact: true,
    icon: <SmileOutlined />,
    name: 'customers',
    permissionKey: '/customers'
  },
  {
    key: Math.random(),
    path: '/customerCredit',
    component: lazy(() => import('../customerCredit')),
    exact: true,
    icon: <PoundOutlined />,
    name: 'customer_credit',
    permissionKey: '/customerCredit'
  },
  {
    key: Math.random(),
    path: '/goodReciveNote',
    component: lazy(() => import('../goodReciveNote')),
    exact: true,
    icon: <BookOutlined />,
    name: 'good_recive_note',
    permissionKey: '/goodReciveNote'
  },
  {
    key: Math.random(),
    path: '/singlePurchaseOrder',
    component: lazy(() => import('../goodReciveNote/QrCode')),
    exact: true,
    name: 'dynamic page PO',
    icon: <BookOutlined />,
    hidden: true,
    permissionKey: '/singlePurchaseOrder'
  },
  {
    key: Math.random(),
    path: '/variantGroups',
    component: lazy(() => import('../variantGroups')),
    exact: true,
    name: 'variant_groups',
    icon: <PlusCircleOutlined />,
    permissionKey: '/variant_groups'
  },
  {
    key: Math.random(),
    path: '/cartChangeLogger',
    component: lazy(() => import('../cartChangeLogger')),
    exact: true,
    name: 'cart_change_logger',
    icon: <RedEnvelopeOutlined />,
    permissionKey: '/cartChangeLogger'
  },
  {
    key: Math.random(),
    path: '/orderStatusChangeLogger',
    component: lazy(() => import('../orderStatusChangeLogger')),
    exact: true,
    name: 'order_status_change_logger',
    icon: <RedEnvelopeOutlined />,
    permissionKey: '/orderStatusChangeLogger'
  },
  {
    key: Math.random(),
    path: '/permissions',
    component: lazy(() => import('../permissions')),
    exact: true,
    icon: <EyeInvisibleOutlined />,
    name: 'permissions',
    permissionKey: '/permissions'
  },
  {
    key: Math.random(),
    path: '/skuDiscounts',
    component: lazy(() => import('../skuDiscounts')),
    exact: true,
    icon: <DisconnectOutlined />,
    name: 'sku_discounts',
    permissionKey: '/skuDiscounts'
  },
  {
    key: Math.random(),
    path: '/driverInvoices',
    component: lazy(() => import('../driverInvoices')),
    exact: true,
    icon: <CarOutlined />,
    name: 'driver_invoices',
    permissionKey: '/driverInvoices'
  },
  {
    key: Math.random(),
    path: '/layouts',
    component: lazy(() => import('../layouts')),
    exact: true,
    icon: <LayoutFilled />,
    name: 'layouts',
    permissionKey: '/layouts'
  },
  {
    key: Math.random(),
    path: '/commonCatalogs',
    component: lazy(() => import('../commonCatalogs')),
    exact: true,
    icon: <LayoutFilled />,
    name: 'common_catalogs',
    permissionKey: '/commonCatalogs'
  },
  {
    key: Math.random(),
    path: '*',
    component: lazy(() => import('../NotFound/NotFound')),
    exact: true,
    icon: <EyeInvisibleOutlined />,
    name: 'Not found',
    hidden: true,
    permissionKey: '/notFound'
  },
];
export default options;